import React, { useState, useContext } from 'react';
import FlowBuilder, {
  NodeContext,
} from 'react-flow-builder'
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Grid from '@mui/material/Grid';
// import Fab from '@mui/material/Fab';
// import AddIcon from '@mui/material/Icon'
import { Button, Popconfirm, Popover } from 'antd';
import "./app.css";

import WaypointRender from './common_node/waypoint_render'
import DirectionRender from './common_node/direction_render'
import CoordinateRender from './common_node/coordinate_render'
import AIRender from './common_node/ai_render'
import WaitRender from './common_node/wait_render'
import BroadcastRender from './common_node/broadcast_render'
import ScreenRender from './common_node/screen_render'
import LocaliseRender from './common_node/localise_render'
import ThermalRender from './common_node/thermal_render'
import PhotoRender from './common_node/photo_render'
import ResumeRender from './common_node/resume_render'

import AICondition from './condition_node/ai_render'

const robot_conditions = [
  {
    type: 0,
    name: "AI",
    condition: <AICondition/>
  }
]

const robot_loop_conditions = [
  {
    type: 0,
    name: "DateTime",
    condition: <AICondition/>
  }
]

const robot_actions = [
  {
    type: 0,
    name: "Waypoint",
    render: <WaypointRender/>
  },
  {
    type: 1,
    name: "Direction",
    render: <DirectionRender/>
  },
  {
    type: 2,
    name: "Coordinate",
    render: <CoordinateRender/>
  },
  {
    type: 3,
    name: "AI",
    render: <AIRender/>
  },
  {
    type: 4,
    name: "Wait",
    render: <WaitRender/>
  },
  {
    type: 5,
    name: "Broadcast",
    render: <BroadcastRender/>
  },
  {
    type: 6,
    name: "Screen",
    render: <ScreenRender/>
  },
  {
    type: 7,
    name: "Localise",
    render: <LocaliseRender/>
  },
  {
    type: 8,
    name: "Thermal",
    render: <ThermalRender/>
  },
  {
    type: 9,
    name: "Take Photo",
    render: <PhotoRender/>
  },
  {
    type: 10,
    name: "Resume",
    render: <ResumeRender/>
  }
]

const StartNodeDisplay = () => {
  const node = useContext(NodeContext);
  return <div className=" start-node "> {node.name} </div>;
};

const EndNodeDisplay = () => {
  const node = useContext(NodeContext);
  return <div className=" end-node "> {node.name} </div>;
};

const NodeDisplay = () => {
  const node = useContext(NodeContext);
  var action_type = 0
  robot_actions.forEach(element => {
    if(node.data && element.name.toLowerCase() === node.data.type){
      action_type = element.type
      // console.log(node.data)
    }
  });
  const [robot_action, setRobotAction] = useState(action_type);

  const handleChange = (event) => {
    setRobotAction(event.target.value.type)
  }

  const setNodeData = (data) => {
    node.data = data
  }

  return (
    <div className=" other-node ">
      <Grid container spacing={{ xs: 4, sm: 4, md: 4, lg: 4, xl: 4 }} >
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <TextField
          select
          id="outlined-required"
          label="Robot Actions"
          // defaultValue={robot_actions[action_type]}
          value={robot_actions[robot_action]}
          name="robot_actions"
          style={{width: "100%"}}
          onChange={handleChange}
        >
          {robot_actions.map((option) => (
            <MenuItem key={option.type} value={option}>
              {option.name}
            </MenuItem>
          ))}
        </TextField>
        </Grid>
        {React.cloneElement(robot_actions[robot_action].render, { setNodeData: setNodeData, nodeData: node.data })}
      </Grid>
    </div>
  );
};

const ConditionNodeDisplay = () => {
  const node = useContext(NodeContext);
  var condition_type = 0
  robot_conditions.forEach(element => {
    if(node.data && element.name.toLowerCase() === node.data.type){
      condition_type = element.type
      // console.log(node.data)
    }
  });
  const [robot_condition, setRobotCondition] = useState(condition_type);
  const handleChange = (event) => {
    setRobotCondition(event.target.value.type)
  }
  const setNodeData = (data) => {
    node.data = data
  }
  return (
    <div className=" other-node ">
      <Grid container spacing={{ xs: 4, sm: 4, md: 4, lg: 4, xl: 4 }} >
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <TextField
          select
          id="outlined-required"
          label="Robot Conditions"
          // defaultValue={robot_actions[action_type]}
          value={robot_conditions[robot_condition]}
          name="robot_actions"
          style={{width: "100%"}}
          onChange={handleChange}
        >
          {robot_conditions.map((option) => (
            <MenuItem key={option.type} value={option}>
              {option.name}
            </MenuItem>
          ))}
        </TextField>
        </Grid>
        {React.cloneElement(robot_conditions[robot_condition].condition, { setNodeData: setNodeData, nodeData: node.data })}
      </Grid>
    </div>
  );
};

const LoopNodeDisplay = () => {
  const node = useContext(NodeContext);
  var condition_type = 0
  robot_loop_conditions.forEach(element => {
    if(node.data && element.name.toLowerCase() === node.data.type){
      condition_type = element.type
      // console.log(node.data)
    }
  });
  const [robot_condition, setRobotCondition] = useState(condition_type);
  const handleChange = (event) => {
    setRobotCondition(event.target.value.type)
  }
  const setNodeData = (data) => {
    node.data = data
  }
  return (
    <div className=" other-node ">
      <Grid container spacing={{ xs: 4, sm: 4, md: 4, lg: 4, xl: 4 }} >
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <TextField
          select
          id="outlined-required"
          label="Robot Loop Conditions"
          // defaultValue={robot_actions[action_type]}
          value={robot_loop_conditions[robot_condition]}
          name="robot_actions"
          style={{width: "100%"}}
          onChange={handleChange}
        >
          {robot_loop_conditions.map((option) => (
            <MenuItem key={option.type} value={option}>
              {option.name}
            </MenuItem>
          ))}
        </TextField>
        </Grid>
        {React.cloneElement(robot_loop_conditions[robot_condition].condition, { setNodeData: setNodeData, nodeData: node.data })}
      </Grid>
    </div>
  );
};
const registerNodes = [
  {
    type: "start",
    name: "start node",
    displayComponent: StartNodeDisplay,
    isStart: true,
  },
  {
    type: "end",
    name: "end node",
    displayComponent: EndNodeDisplay,
    isEnd: true,
  },
  {
    type: "node",
    name: "Robot Actions",
    displayComponent: NodeDisplay,
  },
  {
    type: "condition",
    name: "Condition",
    displayComponent: ConditionNodeDisplay
  },
  {
    type: "loop",
    name: "Loop",
    displayComponent: LoopNodeDisplay,
    isLoop: true,
  },
  {
    type: "branch",
    name: "Branch",
    conditionNodeType: "condition"
  }
];

const defaultNodes = [
  {
    id: "node-0d9d4733-e48c-41fd-a41f-d93cc4718d97",
    type: "start",
    name: "start",
    path: ["0"]
  },
  {
    id: "node-b106675a-5148-4a2e-aa86-8e06abd692d1",
    type: "end",
    name: "end",
    path: ["1"]
  }
];


export default function App() {
  const [nodes, setNodes] = useState(defaultNodes);
  const [height, ] = useState(window.outerHeight);
  const [width, ] = useState(window.outerWidth);
  const [newTaskListName, setNewTaskListName] = useState("Tasklist ".concat(Math.ceil(Math.random() * 1000000)))
  const [selectedTasklist, setCurrentSelectedTasklist] = useState("");
  const [testDataSet, setTestDataSet] = useState([
    {
      tasklist: "Tasklist 1",
      list: [
        {
            "id": "node-0d9d4733-e48c-41fd-a41f-d93cc4718d97",
            "type": "start",
            "name": "start",
            "path": [
                "0"
            ]
        },
        {
            "id": "node-0666175a-b4eb-40f8-8cf1-799628020466",
            "type": "node",
            "name": "Robot Actions",
            "path": [
                "1"
            ],
            "data": {
                "type": "waypoint",
                "selectedWaypoint": "waypoint1",
                "check_reached": true
            }
        },
        {
            "id": "node-44c047c3-352d-47a2-a1d1-94044d6b46dd",
            "type": "node",
            "name": "Robot Actions",
            "path": [
                "2"
            ],
            "data": {
                "type": "waypoint",
                "selectedWaypoint": "waypoint2",
                "check_reached": true
            }
        },
        {
            "id": "node-4aeb1380-9f7d-4ef6-8163-02c5ecef8078",
            "type": "node",
            "name": "Robot Actions",
            "path": [
                "3"
            ],
            "data": {
                "type": "waypoint",
                "selectedWaypoint": "waypoint3",
                "check_reached": true
            }
        },
        {
            "id": "node-b106675a-5148-4a2e-aa86-8e06abd692d1",
            "type": "end",
            "name": "end",
            "path": [
                "4"
            ]
        }
      ]
    },
    {
      tasklist: "Tasklist 2",
      list: [
        {
            "id": "node-0d9d4733-e48c-41fd-a41f-d93cc4718d97",
            "type": "start",
            "name": "start",
            "path": [
                "0"
            ]
        },
        {
            "id": "node-0666175a-b4eb-40f8-8cf1-799628023563",
            "type": "node",
            "name": "Robot Actions",
            "path": [
                "1"
            ],
            "data": {
                "type": "waypoint",
                "selectedWaypoint": "waypoint1",
                "check_reached": true
            }
        },
        {
            "id": "node-44c047c3-352d-47a2-a1d1-94044d6b9876",
            "type": "node",
            "name": "Robot Actions",
            "path": [
                "2"
            ],
            "data": {
                "type": "waypoint",
                "selectedWaypoint": "waypoint2",
                "check_reached": true
            }
        },
        {
            "id": "node-4aeb1380-9f7d-4ef6-8163-02c5ecef4234",
            "type": "node",
            "name": "Robot Actions",
            "path": [
                "3"
            ],
            "data": {
                "type": "waypoint",
                "selectedWaypoint": "waypoint3",
                "check_reached": true
            }
        },
        {
            "id": "node-3787b952-31eb-413e-b34f-2f61010808a2",
            "type": "node",
            "name": "Robot Actions",
            "path": [
                "4"
            ],
            "data": {
                "type": "ai",
                "on": true
            }
        },
        {
            "id": "node-ad2e2740-ac1c-4582-80a5-6265f5fe002a",
            "type": "node",
            "name": "Robot Actions",
            "path": [
                "5"
            ],
            "data": {
                "type": "wait",
                "wait": "180"
            }
        },
        {
            "id": "node-f6ceb88a-b955-4079-96a0-4de094e154b4",
            "type": "node",
            "name": "Robot Actions",
            "path": [
                "6"
            ],
            "data": {
                "type": "ai",
                "on": false
            }
        },
        {
            "id": "node-b99c7bdb-1e56-48a7-8f1e-8370b9ce9d5a",
            "type": "node",
            "name": "Robot Actions",
            "path": [
                "7"
            ],
            "data": {
                "type": "waypoint",
                "selectedWaypoint": "waypoint2",
                "check_reached": true
            }
        },
        {
            "id": "node-b106675a-5148-4a2e-aa86-8e06abd692d1",
            "type": "end",
            "name": "end",
            "path": [
                "8"
            ]
        }
      ]
    }
  ])


  const handleChange = (nodes) => {
    console.log("nodes change", nodes);
    setNodes(nodes);
  };

  const setCurrentTasklist = (tasklist) => {
    setCurrentSelectedTasklist(tasklist)
  }

  const handleReset = () => {
    setNewTaskListName("Tasklist ".concat(Math.ceil(Math.random() * 1000000)))
    const resetNodes = [
      {
        id: "node-".concat(Math.ceil(Math.random() * 1000000)),
        type: "start",
        name: "start",
        path: ["0"]
      },
      {
        id: "node-".concat(Math.ceil(Math.random() * 1000000)),
        type: "end",
        name: "end",
        path: ["1"]
      }
    ];
    console.log("resetting nodes", resetNodes)
    setNodes(resetNodes)
    setCurrentSelectedTasklist("")
  }

  const translateTask = (task) =>{
    if(task.type === "waypoint") {
      return("robot-gotogoal".concat(" ", task.selectedWaypoint))
    } else if (task.type === "direction") {
      return("robot-move".concat(" ", task.selectedDirection))
    } else if (task.type === "coordinate") {
      return("robot-gotopoint".concat(" ", task.angle, " ", task.x, " ", task.y))
    } else if (task.type === "ai") {
      if(task.on) {
        return ("robot-aidetection on")
      } else {
        return ("robot-aidetection off")
      }
    } else if (task.type === "wait") {
      return("robot-wait".concat(" ", task.wait))
    } else if (task.type === "broadcast") {
      return("robot-broadcast".concat(" ", task.message, " ", task.speed))
    } else if (task.type === "screen") {
      return("robot-screen".concat(" ", task.selectedScreen))
    } else if (task.type === "thermal") {
      if(task.on) {
        return ("robot-thermal on")
      } else {
        return ("robot-thermal off")
      }
    } else {
      return ("")
    }
  }

  const handleSave = () => {
    var tasklist = []
    console.log("saving node tree", nodes);
    if(selectedTasklist === newTaskListName){
      var temp = testDataSet
      temp.forEach(element => {
        if(element.tasklist === selectedTasklist){
          element.list = nodes
        }
      });
      setTestDataSet(temp)
    } else {
      const temp = {
          tasklist: newTaskListName,
          list: nodes
        }
      setTestDataSet([...testDataSet, temp])
    }

    nodes.forEach((element, index) => {
      if(element.name === "start" || element.name === "end"){
        tasklist.push({
          timestamp : "",
          task_id : "",
          subtask_id: element.id,
          subtask_seq_id: "",
          subtask_status: "",
          sop_id : "",
          sop_seq_id : index,
          sop_title : element.name,
          sop_status : "",
        })
      } else if (element.name === "Robot Actions"){
        tasklist.push(
          {
            timestamp : "",
            task_id : "",
            subtask_id: element.id,
            subtask_seq_id: "",
            subtask_status: "",
            sop_id : "",
            sop_seq_id : index,
            sop_title : translateTask(element.data),
            sop_status : "",
          }
        )
      } else if (element.name === "Loop") {
        var loop_array = []
        element.children.forEach((child, index)=>{
          loop_array.push(
            {
              timestamp : "",
              task_id : element.id,
              subtask_id: child.id,
              subtask_seq_id: "",
              subtask_status: "",
              sop_id : "",
              sop_seq_id : index,
              sop_title : translateTask(child.data),
              sop_status : "",
            }
          )
        })
        tasklist.push({
          loop_condition: element.data,
          loop_id: element.id,
          loop_array: loop_array
        })
      }
    });
    console.log(tasklist)
    setCurrentSelectedTasklist(newTaskListName)
  }

  const [open, setOpen] = useState(false);

  const handleDrawerOpen = () => {
    setOpen(!open);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleAddTasklist = () => {
    setNewTaskListName("Tasklist ".concat(Math.ceil(Math.random() * 1000000)))
    const resetNodes = [
      {
        id: "node-".concat(Math.ceil(Math.random() * 1000000)),
        type: "start",
        name: "start",
        path: ["0"]
      },
      {
        id: "node-".concat(Math.ceil(Math.random() * 1000000)),
        type: "end",
        name: "end",
        path: ["1"]
      }
    ];
    console.log("resetting nodes", resetNodes)
    setNodes(resetNodes)
  }

  const handleDelete = () => {
    const temp = [...testDataSet];
    var deleted = "No such tasklist"
    temp.forEach((element, index) => {
      if(selectedTasklist !== "" && selectedTasklist  === element.tasklist){
        console.log(element)
        deleted = "deleted " + element.tasklist
        temp.splice(index, 1);
      }
    });
    setTestDataSet(temp);
    console.log(deleted)
    handleReset()
  }

  return (
    <div style={{ width: width, height: height, display: "flex", flexDirection: "column"}}>

      <FlowBuilder
        // draggable
        // DropComponent={DropComponent}
        zoomTool={{
          hidden: false,
          min: 10,
          max: 150,
          step: 25
        }}
        historyTool={{
          max: 5
        }}
        nodes={nodes}
        onChange={handleChange}
        registerNodes={registerNodes}
        // DrawerComponent={Drawer}
        PopoverComponent={Popover}
        PopconfirmComponent={Popconfirm}
        showArrow={true}
      />

      <div style={{ width: 400, height: 50, display: "flex", flexDirection: "row", position: "fixed"}}>
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{display: "flex", alignItems:'center', justifyContent:"center"}}>
            <Grid item xs={3} sm={3} md={3} lg={3} xl={3} style={{display: "flex", alignItems:'center', justifyContent:"center"}}>
            <Button style={{width: 80}} onClick={handleSave}>Save</Button>
            </Grid>
            <Grid item xs={3} sm={3} md={3} lg={3} xl={3} style={{display: "flex", alignItems:'center', justifyContent:"center"}}>
            <Button style={{width: 80}} onClick={handleReset}>Reset</Button>
            </Grid>
            <Grid item xs={3} sm={3} md={3} lg={3} xl={3} style={{display: "flex", alignItems:'center', justifyContent:"center"}}>
            <Button style={{width: 80}} onClick={handleDelete}>Delete</Button>
            </Grid>
            <Grid item xs={3} sm={3} md={3} lg={3} xl={3} style={{display: "flex", alignItems:'center', justifyContent:"center"}}>
            <Button style={{width: 80}} onClick={handleDrawerOpen}>Tasklists</Button>
            </Grid>
          </Grid>
        </Grid>
      </div>

      <Drawer variant="persistent" anchor="right" open={open} sx={{width: 50,}}>
        <div>
          <div>
            <IconButton onClick={handleDrawerClose}>
              <ChevronLeft />
            </IconButton>
          </div>
        <List>
          {testDataSet.map((item, index) => (
            <ListItem button key={index} onClick={()=>{console.log(item.tasklist); handleChange(item.list); setNewTaskListName(item.tasklist); setCurrentTasklist(item.tasklist)}}>
              <ListItemText primary={item.tasklist} />
            </ListItem>
          ))}
        </List>
        </div>
        <div>
          <IconButton onClick={handleAddTasklist} style={{width: "100%"}}>
            +
          </IconButton>
        </div>
      </Drawer>
      </div>

  );
}